(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-volumetria', {
            parent: 'app',
            url: '/chamados-por-volumetria',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados por Volumetria'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-volumetria/chamados-por-volumetria.html',
                    controller: 'ChamadosPorVolumetriaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
